const OFF_CAPTION_LABEL = "off";

const getCaptionTrackIndex = (captionsList = []) => {
  if (!Array.isArray(captionsList) || captionsList.length <= 1) return -1;
  const trackIndex = captionsList.findIndex((track, index) => {
    if (index === 0) return false;
    const label = String(track?.label || track?.name || "").trim().toLowerCase();
    return label !== OFF_CAPTION_LABEL;
  });
  return trackIndex > 0 ? trackIndex : 1;
};

export const enableDefaultCaptions = (player) => {
  if (!player) return () => {};

  let applied = false;
  let fallbackTimer = null;

  const applyDefaultCaptions = () => {
    if (applied) return;
    const list = typeof player.getCaptionsList === "function" ? player.getCaptionsList() : [];
    const trackIndex = getCaptionTrackIndex(list);
    if (trackIndex < 1) return;

    try {
      const currentIndex = typeof player.getCurrentCaptions === "function"
        ? Number(player.getCurrentCaptions())
        : 0;
      if ((Number.isNaN(currentIndex) || currentIndex < 1) && typeof player.setCurrentCaptions === "function") {
        player.setCurrentCaptions(trackIndex);
      }
      applied = true;
    } catch (e) {}
  };

  if (typeof player.on === "function") {
    player.on("captionsList", applyDefaultCaptions);
  }
  applyDefaultCaptions();
  fallbackTimer = setTimeout(applyDefaultCaptions, 300);

  return () => {
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
    if (typeof player.off === "function") {
      player.off("captionsList", applyDefaultCaptions);
    }
  };
};
